import { ActivityType } from '@/app/constants/activity'
import {
  faTruckSolid,
  faBedFrontSolid,
  faQuestionCircleSolid,
  faIdBadgeSolid,
  faHammerSolid,
  faSteeringWheelSolid,
  faBedEmptySolid,
  faBedEmptyRegular,
  faSteeringWheelRegular,
  faHammerRegular,
  faIdBadgeRegular,
  faQuestionCircleRegular,
} from '@/lib/fa'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { getActivityType } from './ActivityTypeResolver'
import { ActivityModel } from '@/app/models'

export const getActivityIcon = (type: number) => {
  let icon: IconProp = faTruckSolid

  switch (type) {
    case 1:
      icon = faIdBadgeRegular
      break
    case 2:
      icon = faHammerRegular
      break
    case 3:
      icon = faSteeringWheelRegular
      break
    case 0:
      icon = faBedEmptyRegular
      break
    case 4:
      icon = faQuestionCircleRegular
      break
  }

  return icon
}

export const getActivityIconSolid = (type: number) => {
  let icon: IconProp = faTruckSolid

  switch (type) {
    case 1:
      icon = faIdBadgeSolid
      break
    case 2:
      icon = faHammerSolid
      break
    case 3:
      icon = faSteeringWheelSolid
      break
    case 0:
      icon = faBedEmptySolid
      break
    case 4:
      icon = faQuestionCircleSolid
      break
  }

  return icon
}
export const getActivityNavbarIcon = (activity: ActivityModel) => {
  const type = getActivityType(activity.type)
  let icon: IconProp = faTruckSolid
  switch (type) {
    case ActivityType.AVAILABILITY:
      icon = faHammerSolid
      break

      break
    case ActivityType.WORK:
      icon = faHammerSolid
      break
    case ActivityType.DRIVING:
      icon = faSteeringWheelSolid
      break
    case ActivityType.REST:
      icon = faBedEmptySolid
      break
    case ActivityType.UNKNOWN:
      icon = faHammerSolid
      break
  }

  return icon
}
export const getActivityBlackIcon = (type: number) => {
  let icon: IconProp = faTruckSolid

  switch (type) {
    case 1:
      icon = faIdBadgeSolid
      break
    case 2:
      icon = faHammerSolid
      break
    case 3:
      icon = faTruckSolid
      break
    case 0:
      icon = faBedFrontSolid
      break
    case 4:
      icon = faQuestionCircleSolid
      break
  }

  return icon
}
